import React from "react";
import "../styles/Contact.css";
import { SiFacebook, SiTwitter, SiLinkedin, SiGmail } from "react-icons/si";
import { RiFileDownloadFill } from "react-icons/ri";

export default function Contact() {
  const contactendLine = "Designed & Built by Karthikeya";

  return (
    <div id="contact" className="ContactContainer">
      <div className="ContactDetailsContainer">
        <div className="OtherDetails">
          <div className="OtherDetailsSub">
            <div className="GetInTouchText">
              <h1>Get In Touch</h1>
            </div>
            <span className="GetInTouchDesc">
            As a dedicated student on the path of DataScience, I'm actively seeking opportunities to expand my horizons and contribute to exciting projects. Whether it's internships, collaborations, or engaging conversations about potential ventures, I'm enthusiastic about forging connections with professionals and fellow enthusiasts. Please reach out—I'm genuinely excited to explore how we can join forces to turn ideas into reality and fuel our collective success.
            </span>
            <div className="SayHelloButton">
              <a
                href="mailto:yedlakarthikeya.iitbbs@gmail.com"
                target="_blank"
                rel="noopener noreferrer"
                className="SayHello"
              >
                Say Hello
              </a>
            </div>
          </div>
        </div>
        <div className="ContactDetails">
          <div>
            <ul className="ContactsList">
              
              <li>
                <a
                  href="https://www.linkedin.com/in/karthikeya-yedla-a21a09210/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <SiLinkedin size="1.75em" color="white" />
                </a>
              </li>
              <li>
                <a
                  href="mailto:yedlakarthikeya.iitbbs@gmail.com"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <SiGmail size="1.75em" color="white" />
                </a>
              </li>
              <li>
                <a
                  href="https://twitter.com/KarthikeyaYedla"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <SiTwitter size="1.75em" color="white" />
                </a>
              </li>
              <li>
                <a
                  href="https://drive.google.com/file/d/1EEm8nuhwk3QVtgJnl6b2vdwIfgDXhzFJ/view?usp=drive_link"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <RiFileDownloadFill size="1.75em" color="white" />
                </a>
              </li>
            </ul>
          </div>
          <div className="ContactDetailsBottom">
            <span>{contactendLine}</span>
          </div>
        </div>
      </div>
    </div>
  );
}
